import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicCard from './BasicCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/basic/BasicCard.tsx",
    "fileName": "BasicCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nconst bull = (\n  <Box\n    component=\"span\"\n    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}\n  >\n    •\n  </Box>\n);\n\nexport default function BasicCard() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card sx={{ minWidth: 275 }}>\n      <CardContent>\n        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>\n          Word of the Day\n        </Typography>\n        <Typography variant=\"h5\" component=\"div\">\n          be{bull}nev{bull}o{bull}lent\n        </Typography>\n        <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>\n        <Typography variant=\"body2\">\n          well meaning and kindly.\n          <br />\n          {'\"a benevolent smile\"'}\n        </Typography>\n      </CardContent>\n      <CardActions>\n        <Button size=\"small\">Learn More</Button>\n      </CardActions>\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 39,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nconst bull = (\n  <Box\n    component=\"span\"\n    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}\n  >\n    •\n  </Box>\n);\n\nexport default function BasicCard() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card sx={{ minWidth: 275 }}>\n      <CardContent>\n        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>\n          Word of the Day\n        </Typography>\n        <Typography variant=\"h5\" component=\"div\">\n          be{bull}nev{bull}o{bull}lent\n        </Typography>\n        <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>\n        <Typography variant=\"body2\">\n          well meaning and kindly.\n          <br />\n          {'\"a benevolent smile\"'}\n        </Typography>\n      </CardContent>\n      <CardActions>\n        <Button size=\"small\">Learn More</Button>\n      </CardActions>\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 39,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Card",
      "@mui/material/CardActions",
      "@mui/material/CardContent",
      "@mui/material/Button",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
